import React, { useState } from 'react';

const Logo: React.FC = () => {
  const [imageError, setImageError] = useState(false);

  return (
    <div className="logo-container mb-8">
      {!imageError ? (
        <img 
          src="/assets/logo-streetvape.png"
          alt="Street Vape Logo - Tienda de Vapeo Próximamente" 
          className="max-w-full w-64 md:w-80 lg:w-96 h-auto mx-auto"
          onError={() => {
            console.error('Logo image failed to load');
            setImageError(true);
          }}
        />
      ) : (
        <div className="w-64 md:w-80 lg:w-96 h-24 md:h-32 lg:h-40 mx-auto bg-gray-100 flex items-center justify-center">
          <span className="text-xl font-bold">Street Vape</span>
        </div>
      )}
    </div>
  );
};

export default Logo;